export const ADD_NEW_ANNOUNCEMENT = "ANNOUNCEMENT/ADD_NEW_ANNOUNCEMENT";
export const DELETE_ANNOUNCEMENT = "ANNOUNCEMENT/DELETE_ANNOUNCEMENT";
export const UPDATE_ANNOUNCEMENT = "ANNOUNCEMENT/UPDATE_ANNOUNCEMENT";
export const FETCH_ANNOUNCEMENTS = "ANNOUNCEMENTS/FETCH_ANNOUNCEMENTS";
export const HIDE_ANNOUNCEMENT_BAR = "ANNOUNCEMENT/HIDE_ANNOUNCEMENT_BAR";
export const UPDATE_STORE_ANNOUNCEMENTS = "ANNOUNCEMENTS/UPDATE_STORE_ANNOUNCEMENT";
export const EDIT_ANNOUNCEMENT_BAR_COLOR = "ANNOUNCEMENT/EDIT_ANNOUNCEMENT_BAR_COLOR";
export const REORDER_ANNOUNCEMENTS = "ANNOUNCEMENTS/REORDER_ANNOUNCEMENTS";
